import { useParams } from 'react-router';

/**
 * Caminhos da loja. No modo normal a loja vive sob `/loja/<slug>`; no modo "domínio próprio" (host) ela ocupa a raiz
 * do domínio e o prefixo some. O modo é decidido uma vez no boot (`main.tsx`) por `setHostStore`.
 */
let hostSlug: string | null = null;

/** Liga o modo host: a loja `slug` é servida na raiz do domínio atual. `null` volta ao modo normal. */
export function setHostStore(slug: string | null) {
  hostSlug = slug;
}
export const isHostMode = () => hostSlug !== null;
export const getHostSlug = () => hostSlug;

/** `/loja/<slug>` no modo normal; `''` no modo host. */
export function storeBase(slug: string, host: boolean = isHostMode()): string {
  return host ? '' : `/loja/${slug}`;
}

/** `storePath('x', '/catalogo')` => `/loja/x/catalogo` (normal) ou `/catalogo` (host). Aceita sem barra inicial e com query. */
export function storePath(slug: string, path = '', host: boolean = isHostMode()): string {
  let p = path === '/' ? '' : path;
  if (p && !p.startsWith('/') && !p.startsWith('?') && !p.startsWith('#')) p = `/${p}`;
  const out = `${storeBase(slug, host)}${p}`;
  if (out === '') return '/';
  return out.startsWith('?') || out.startsWith('#') ? `/${out}` : out;
}

/** No modo host, `/loja/<slug>/x?y` vira `/x?y` (links antigos, ex.: CTA do banner). Fora do modo host, devolve igual. */
export function localizeStorePath(path: string, host: boolean = isHostMode()): string {
  if (!host) return path;
  const m = /^\/loja\/[^/?#]+(.*)$/.exec(path);
  if (!m) return path;
  const rest = m[1] ?? '';
  return rest === '' || rest.startsWith('?') || rest.startsWith('#') ? `/${rest}` : rest;
}

/** Slug da loja na tela atual: parâmetro `:orgSlug` (modo normal) ou a loja do domínio (modo host). */
export function useOrgSlug(): string {
  const { orgSlug } = useParams();
  return orgSlug ?? hostSlug ?? '';
}
